module.exports = __webpack_public_path__ + "img/null.b8fff866.png";